/* eslint-disable */
import { BsCodeSlash, BsClipboardData, BsBarChart } from "react-icons/bs";
import { FaRegNewspaper } from "react-icons/fa";
import { MdWeb } from "react-icons/md";

export const servicesData = [
    {
        id: 1,
        title: 'Full-Stack Development',
        icon: <BsCodeSlash />
    },
    {
        id: 2,
        title: 'Data Analysis',
        icon: <BsBarChart />
    },
    {
        id: 3,
        title: 'Problem Solving',
        icon: <BsClipboardData />
    },
    {
        id: 4,
        title: 'Blog Writing',
        icon: <FaRegNewspaper />
    },
    {
        id: 5,
        title: 'Frontend Development',
        icon: <MdWeb />
    },

    
];
